module.exports = __webpack_public_path__ + "img/IT0000064582025.f892afab.png";